import React, { useState, useRef, useEffect, useContext } from 'react';
import Navbar2 from './Navbar2';
import songImage from '../assets/5532836.png';
import shift from '../assets/shift.mp3';
import { IoPlayCircleOutline } from "react-icons/io5";
// import { IoPauseCircleOutline } from "react-icons/io5";
import { IoStopCircleOutline } from "react-icons/io5"; 
import { getAppData } from '../apiService';
import { ApiContext } from '../context/ApiContext';
import PopUp from './PopUp';
import useGetDataFromTunes from '../Hooks/useGetDataFromTunes';
import { ShimmerCircularImage, ShimmerFeaturedGallery, ShimmerText, ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects';
import WaveForm from './WaveForm';

function Home() {

  const { data, audioRef, togglePlayPause5, isPlayings, isPlayingOrNot, innerAudioRef, setIsPlayingOrNot, togglePlayPause, songData, interviewsisPlaying, interviewstogglePlayPause,analyzerData, setAnalyzerData } = useContext(ApiContext)

  const [datasss, setDatasss] = useState(null);
  // const [loading, setLoading] = useState(true);

  // const [isAndroid, setIsAndroid] = useState(false);
  // const [isApple, setIsApple] = useState(false);
  // const [isWindows, setIsWindows] = useState(false);

  // useEffect(() => {
  //   if (navigator.userAgent.match(/Android/i)) {
  //     setIsAndroid(true);
  //   } else if (navigator.userAgent.match(/iPhone|iPod/i)) {
  //     setIsApple(true);
  //   } else {
  //     setIsWindows(true);
  //   }
  // }, []);
  // Empty dependency array ensures it runs only once

  // Only run useGetDataFromTunes if songData is available
  // let datasss = 

  const fetchedData = useGetDataFromTunes(songData);

  useEffect(() => {
    if (songData) {
      setDatasss(fetchedData);
      console.log(fetchedData,"fe");
      
      // console.log(datasss,"dadadaddadadadadddsds");

    }
  }, [songData, fetchedData])

  useEffect(() => {
    if (isPlayings) {
      if (audioRef.current) {
        audioRef.current.play().catch((error) => console.error("Play error:", error));
        if (isPlayingOrNot) {
          togglePlayPause()

        }
        if (interviewsisPlaying) {
          interviewstogglePlayPause()
          // setinterviewsisPlaying(prev=>!prev)
        }
      }
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
      }
      // if (isPlayingOrNot) {
      //   togglePlayPause()
      // }
    }
  }, [isPlayings, audioRef, setIsPlayingOrNot]);

  // useEffect(()=>{
  //   if (!data) {
  //     return (
  //       <div className="loader-container">
  //           <div className="dot-wave-loader">
  //               <div></div>
  //               <div></div>
  //               <div></div>
  //               <div></div>
  //               <div></div>
  //           </div>
  //       </div>
  //   );
  //   }
  //  })

  const audioData = {
    title: "Relaxing Nature Sounds",
    artist: "Nature Harmony",
    album: "Peaceful Moments",
    genre: "Ambient",
    duration: 3600,  // duration in seconds
    release_date: "2024-05-15",
    bitrate: 320,  // bitrate in kbps
    sample_rate: 44100,  // sample rate in Hz
    channels: 2,  // number of audio channels
    file_format: "mp3",
    file_size: 86400000,  // file size in bytes
    track_number: 1,
    composer: "John Doe",
    copyright: "© 2024 Nature Harmony Records",
    description: "An hour of soothing nature sounds to help you relax and unwind."
  };


  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [Volume, setVolume] = useState(50);
  const rangeRef = useRef(null);

  const handleVolume = (e) => {
    let volume = e.target.value;
    setVolume(volume);
    audioRef.current.volume = volume / 100;
  }
  // if(loading){ return (
  //   <div className="loader-container">
  //     <div className="dot-wave-loader">
  //       <div></div>
  //       <div></div>
  //       <div></div>
  //       <div></div>
  //       <div></div>
  //     </div>
  //   </div>
  // )
  // }
  return (
    <div className='layout-div'>
      <Navbar2 />
      {data ? <div className='Home-main'>
        {/* {isAndroid?alert("i am in android"):isApple?alert("i am in apple"):isWindows?alert("i am in windows"):alert("Device doesnot recognize")} */}
        <div className='Home-main-inner-div'>
          <div className='rendom-123'>
          <div className='Home-song-name'>
            {/* <p className='Home-song-name-title'>{audioData.title}</p> */}
            <p className='Home-song-name-title'>{!datasss?.title || datasss.title.length === 0 ? "Song name not available" : datasss.title}</p>
            {/* <PopUp/> */}
            <p className='Home-song-name-more'>{!datasss?.artist || datasss.artist.length === 0 ? "Artist name not available" : datasss.artist}</p>
          </div>
          <div className='Home-song-image' >
            <img src={datasss && datasss.thumbnail ? datasss.thumbnail : songImage} alt="song image" width="100%" height="100%" />
          </div>
          </div>
          {analyzerData && <WaveForm analyzerData={analyzerData} />}
          {/* {console.log(analyzerData,"analyzed data")  } */}
      <div
        style={{
          height: 40,
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center"
        }}
      ></div>
          <div className='Home-audio-file-div'>
            <div className="custom-audio-player">
              {/* <audio
                ref={audioRef}
                src={shift}
                onLoadedMetadata={onLoadedMetadata}
                onTimeUpdate={onTimeUpdate}
                onError={(e) => console.error('Audio error: ', e)}
              /> */}
   
              <button className="Home-btn" onClick={togglePlayPause5}>
                {isPlayings ? <IoStopCircleOutline /> : <IoPlayCircleOutline />}
              </button>
              <div className='Home-div'>
                <input type="range" min='0' max="100" value={Volume} onChange={(e) => handleVolume(e)} style={{
                  backgroundImage: `linear-gradient(#000,#000)`,
                  backgroundSize: `${Volume}% 100%`,
                  backgroundRepeat: "no-repeat"
                }} />
                {/* <input
                type="range"
                ref={rangeRef}
                value={currentTime}
                max={duration}
                // oninput="rangevalue.value = this.value"
                onInput={(e) => rangevalue.value = e.target.value}
                onChange={handleSliderChange}
                style={{
                  backgroundImage: `linear-gradient(#000,#000)`,
                  backgroundSize: `${(currentTime / duration) * 100}% 100%`,
                  backgroundRepeat: "no-repeat"
                }}
              /> */}
              </div>
              {/* <span>{Math.floor(currentTime)} / {Math.floor(duration)}</span> */}
            </div>
          </div>
        </div>
      </div> : <>
        <div className='Home-main'>
          <div className='Home-main-inner-div'>
              <div className='rendom-123'>
            <div className='Home-song-name'>
              <div className='Home-song-name12345678'>
                <ShimmerTitle line={1} gap={10} variant="primary" />
                {/* <ShimmerText line={1} gap={5} /> */}
                <ShimmerText line={1} gap={5} />
              </div>
              <div className='Home-song-image-shimmmer-thumb'>

                <ShimmerThumbnail height={300} width={300} />
              </div>
            </div>
              </div>
              
            <div className='Home-audio-file-div'>
              <div className='custom-audio-player'>
                <div className="Home-btn"><ShimmerCircularImage size={35} style={{ padding: "0px", margin: "0px" }} /></div>
                <div className='Home-div123456789'>
                  <ShimmerText line={1} gap={5} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* // <div className="loader-container">
      //     <div className="dot-wave-loader">
      //       <div></div>
      //       <div></div>
      //       <div></div>
      //       <div></div>
      //       <div></div>
      //     </div>
      //   </div> */}
      </>
      }
    </div>
  );
}

export default Home;
